/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'cross-flow-support.back-to-all-products': 'Retour à toutes les apps',
  'cross-flow-support.close': 'Fermer',
  'cross-flow-support.product-store': "Boutique d'applications",
};
